// AIMARGIN1: what the location's AI help settings say about how AI is billed. A customer is told what they are
// charged and their limits, never our cost or markup; the rate is shown only in the software owner console.

/** The "How it is billed" row. `rateSet` false means AI help cannot run yet. */
export function aiBilledWords(rateSet: boolean, billedOnAccount: string | null): string {
  if (!rateSet) return "No AI rate is set for this location yet, so AI help cannot run. Ask Snip & Sip to set one.";
  const owner = billedOnAccount === null ? "" : ` It is charged on ${billedOnAccount}'s bill.`;
  return `Each AI request is billed to your account. This month's charges are shown below.${owner}`;
}
